import styled from "styled-components";
import Header from "../Header";

const MainLayout = ({ children }) => {
  return (
    <div>
      <Header />
      <Main>{children}</Main>
    </div>
  );
};
export default MainLayout;

const Main = styled.main`
  height: 100%;
  display: flex;

  @media (max-width: 991px) {
    flex-direction: column-reverse;
  }

  aside {
    flex: 0 0 320px;

    @media (max-width: 991px) {
      flex: 0 0 100%;
    }
  }

  .stage-wrapper {
    flex-grow: 1;
  }
`;
